import type { JSX } from "react";
import { useI18n } from "../../shared/i18n/I18nContext";
import { Alert } from "../../shared/ui/Alert";
import { useUnsentCountOnDevice } from "./useUnsentCountOnDevice";

/**
 * Warning in the status area of the operator area (F-84): an account with a tenant role and a
 * platform role may have recorded entries in the application of the tenants that the server has not
 * received. The operator area synchronizes nothing (F-69) and the sign-out deletes them, so the
 * number is named on every page instead of losing them silently. A static callout, not announced on
 * every page change.
 *
 * @returns The warning, or nothing without unsent entries.
 */
export function PlatformUnsentNotice(): JSX.Element | null {
  const { t } = useI18n();
  const count = useUnsentCountOnDevice();

  if (count === null || count === 0) {
    return null;
  }

  const notice = (
    <Alert tone="warning" live="off">
      {t("platform.unsent", { count })}
    </Alert>
  );

  return notice;
}
